import { Component, OnInit } from '@angular/core';
import { MainService } from '../services/main.service';
import { UtilService } from '../services/util.service';
import { APP_MODEL_DATA } from '../model-data/app-model-data';
import { jwtDecode } from "jwt-decode";
import { RouteInfoService } from '../services/route-info.service';
import { portalVersion } from '../constants/app-constants';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  isCollapsedNavbar = false;
  showNavbar: boolean = true;
  hideHeader :boolean = false;

  UserName: string = "";
  isUserMenu: boolean = false;
  isDeviceMenu: boolean = false;
  userFirstName: any;
  userLastName: any;
  userFirstNameDisplayChar: any;
  userLastNameDisplayChar: any;
  initialsToDisplay: any;
  isSitesTab: boolean = false;
  isUsersTab: boolean = true;
  isBusinessTab: boolean = false;
  currentUrl: string | undefined;
  isEquipmentsTab: boolean = false;
  portalVersion:any;

  constructor(public utilService: UtilService,
    public mainService: MainService,
    private routeInfoService: RouteInfoService,
    private router: Router) {
  }


  ngOnInit(): void {
    this.portalVersion = portalVersion;
    this.utilService.hideHeader.subscribe((response) => {
      this.hideHeader = response;
      if (!response) {
        this.getLoggedInUserDetails();
      }
    });
    this.utilService.showNavigationBar.subscribe((response) => {
      this.UserName = this.utilService.getLocalStorage("UserName") ? this.utilService.getLocalStorage("UserName")!.toString() : "";
      const userRole = (this.utilService.getLocalStorage('userRole') || '').toString().toLowerCase();

      this.showNavbar = userRole === APP_MODEL_DATA.INTERNAL ? false : response;
      this.getLoggedInUserDetails();
    });
    this.utilService.getSignedInMessage.subscribe((response) => {
      if (response) {
        this.getLoggedInUserDetails();
      }
    });
    this.routeInfoService.routeInfo.subscribe(routeState => {
      this.checkTabRoute(routeState);
    });
    this.getLoggedInUserDetails();
  }

  getLoggedInUserDetails() {
    const tokenValue = this.utilService.getToken('idToken');
    const decodedTokenValue = this.getDecodedAccessToken(tokenValue);
    const storedFirstName = (this.utilService.getLocalStorage("loggedInUserFirstName") || "").toString();
    const storedLastName = (this.utilService.getLocalStorage("loggedInUserLastName") || "").toString();
    const storedUserName = (this.utilService.getLocalStorage("UserName") || "").toString();
    this.userFirstName = decodedTokenValue?.given_name || storedFirstName;
    this.userLastName = decodedTokenValue?.family_name || storedLastName;
    /** As confirmed by Casey on 10/03/2024, we will use the Firstname Lastname format only in this specific instance. 
 * For all other places, we will follow the Lastname, Firstname format. 
 * https://zodiacpoolsystems.atlassian.net/browse/IQ-2306*/
    this.initialsToDisplay = this.getInitialsToDisplay(
      this.userFirstName,
      this.userLastName,
      decodedTokenValue?.name,
      decodedTokenValue?.email || decodedTokenValue?.preferred_username || storedUserName
    );
  }

  getInitialsToDisplay(firstName: string, lastName: string, fullName?: string, email?: string): string {
    const sourceParts = firstName || lastName
      ? [firstName, lastName]
      : (fullName || email?.split('@')[0] || '').split(/[._\s-]+/);
    const parts = sourceParts.map((part) => part?.trim()).filter(Boolean);
    return `${parts[0]?.charAt(0) || ''}${parts.length > 1 ? parts[parts.length - 1].charAt(0) : ''}`.toUpperCase();
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch (Error) {
      return null;
    }
  }

  signOut() {
    this.utilService.showSpinner(APP_MODEL_DATA.APP_SPINNER);
    this.mainService.gSuiteSignOut().subscribe({
      next: () => {
        this.utilService.hideSpinner(APP_MODEL_DATA.APP_SPINNER);
        this.utilService.signout()
      }
    });
  }

  // IQ-1083 - Activating respective tabs when user clicks on it
  checkTabRoute(currentRoute: string): void {
    if (currentRoute.includes(APP_MODEL_DATA.SITES)) {
      this.isSitesTab = true;
      this.isUsersTab = false;
      this.isBusinessTab = false;
      this.isEquipmentsTab = false;
    } else if (currentRoute.includes(APP_MODEL_DATA.SUPPORT_USERS)) {
      this.isSitesTab = false;
      this.isUsersTab = true;
      this.isBusinessTab = false;
      this.isEquipmentsTab = false;
    } else if(currentRoute.includes(APP_MODEL_DATA.EQUIPMENT)) {
      this.isSitesTab = false;
      this.isUsersTab = false;
      this.isBusinessTab = false;
      this.isEquipmentsTab = true;
    } else if(currentRoute.includes(APP_MODEL_DATA.BUSINESSES)) {
      this.isSitesTab = false;
      this.isUsersTab = false;
      this.isEquipmentsTab = false;
      this.isBusinessTab = true;
    }
  }

  onNavigationAttempt(route: string, event?: Event): void {
    const userRole = (this.utilService.getLocalStorage('userRole') || '').toString().toLowerCase();
    if (userRole === APP_MODEL_DATA.INTERNAL) {
      event?.preventDefault();
      this.router.navigate(['/access-restricted']);
      return;
    }

    this.checkTabRoute(route);
  }
}
